export default  {
    component: 'user',
    name: 'user',
    fields: [
          {
            name: 'User ID',
            param: 'user_id',
            type: 'number',
            required: true,
            identifier: true
          },
          {
            name: 'Name',
            param: 'name',
            type: 'text',
          },
          {
            name: 'Email',
            param: 'email',
            type: 'text',
          },
          {
            name: 'Password',
            param: 'password',
            type: 'text',
          },
          {
            name: 'Role',
            param: 'role',
            type: 'text',
          },
          {
            name: 'Contact',
            param: 'contact',
            type: 'number',
          },
          {
            name: 'Profile URL',
            param: 'profile_url',
            type: 'text',
          },
          {
            name: 'Theme',
            param: 'theme',
            type: 'text',
          },
          {
            name: 'Logo',
            param: 'logo',
            type: 'text',
          },
          {
            name: 'Header Components',
            param: 'header_components',
            type: 'text',
          },
          {
            name: 'Expiry Date',
            param: 'expiry_date',
            type: 'number',
          },
          {
            name: 'Last Viewed Notification Time',
            param: 'last_viewed_notification_time',
            type: 'number',
          },
          {
            name: 'Refresh Time',
            param: 'refresh_time',
            type: 'number',
          },
          {
            name: 'Banner Messages',
            param: 'banner_messages',
            type: 'json',
          }
  // device_id
  // inverter_name
  // added_on
  // updated_on
  // updated_by
  // inverter_room
    ]
  }







